import React, { FC } from 'react';

import type { GridRootProp } from './Grid.styles';
import GridRoot from './Grid.styles';

export type GridProps = Partial<GridRootProp> &
  React.HTMLAttributes<HTMLDivElement>;

const Grid: FC<GridProps> = ({
  alignContent = 'stretch',
  alignItems = 'stretch',
  container = false,
  direction = 'row',
  item = false,
  justify = 'flex-start',
  lg = false,
  md = false,
  sm = false,
  spacing = 0,
  wrap = 'wrap',
  xl = false,
  xs = false,
  ...other
}) => {
  const props = {
    alignContent,
    alignItems,
    container,
    direction,
    item,
    justify,
    lg,
    md,
    sm,
    spacing,
    wrap,
    xl,
    xs,
    ...other,
  };

  return <GridRoot {...props} />;
};

export default Grid;
